/* ========================================================================
 * Bootstrap: transition.js v3.3.6
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
	'use strict';

	// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	// ============================================================

	function transitionEnd() {
		var el = document.createElement('bootstrap');

		var transEndEventNames = {
			WebkitTransition: 'webkitTransitionEnd',
			MozTransition: 'transitionend',
			OTransition: 'oTransitionEnd otransitionend',
			transition: 'transitionend'
		};

		for (var name in transEndEventNames) {
			if (el.style[name] !== undefined) {
				return { end: transEndEventNames[name] };
			}
		}

		return false;// explicit for ie8 (  ._.)
	}

	// http://blog.alexmaccaw.com/css-transitions
	$.fn.emulateTransitionEnd = function (duration) {
		var called = false;
		var $el = this;
		$(this).one('bsTransitionEnd', function () { called = true; });
		var callback = function () { if (!called) $($el).trigger($.support.transition.end); };
		setTimeout(callback, duration);
		return this;
	};

	$(function () {
		$.support.transition = transitionEnd();

		if (!$.support.transition) return

		$.event.special.bsTransitionEnd = {
			bindType: $.support.transition.end,
			delegateType: $.support.transition.end,
			handle: function (e) {
				if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
			}
		};
	});

}(jQuery);

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {
				// JavaScript to be fired on all pages

				var isLateralNavAnimating = false;

				// open/close lateral navigation
				$('.menu-drawer').on('click', function (event) {
					event.preventDefault();
					//stop if nav animation is running
					if (!isLateralNavAnimating) {
						if ($(this).parents('.csstransitions').length > 0) {
							isLateralNavAnimating = true;
						}
						$('body').toggleClass('navigation-is-open');
						$('.nav-wrapper').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
							//animation is over
							isLateralNavAnimating = false;
						});
					}
				});

				$('#menu-hauptmenue li.menu-item-has-children').doubleTapToGo();

				$('#menu-hauptmenue li.menu-item-has-children').click(function () {
					$(this).children('.sub-menu').toggleClass('menu--open');
				});

				// Accordion Toggle
				if ($('.faq__list li').length >= 10) {
					$('.faq__question').on('click', function (e) {
						e.preventDefault();
						if ($(this).hasClass('active')) {
							$(this).removeClass('active');
							$(this).next()
								.stop()
								.slideUp(300);
						} else {
							$(this).addClass('active');
							$(this).next()
								.stop()
								.slideDown(300);
						}
					});
				} else {
					$('.faq__question').addClass('active');
					$('.faq__answer').slideDown(300);
					$('.faq__question').on('click', function (e) {
						e.preventDefault();
						if ($(this).hasClass('active')) {
							$(this).removeClass('active');
							$(this).next()
								.stop()
								.slideUp(300);
						} else {
							$(this).addClass('active');
							$(this).next()
								.stop()
								.slideDown(300);
						}
					});
				}


				// Cache selectors outside callback for performance.
				var $window = $(window),
					$stickyEl = $('.sidebar__sticky'),
					elTop = $stickyEl.offset().top;

				$window.scroll(function () {
					$stickyEl.toggleClass('sticky', $window.scrollTop() > elTop);
				});

				/**
				 * selectFx.js v1.0.0
				 * http://www.codrops.com
				 *
				 * Licensed under the MIT license.
				 * http://www.opensource.org/licenses/mit-license.php
				 *
				 * Copyright 2014, Codrops
				 * http://www.codrops.com
				 */
				; (function (window) {

					'use strict';

					/**
					 * based on from https://github.com/inuyaksa/jquery.nicescroll/blob/master/jquery.nicescroll.js
					 */
					function hasParent(e, p) {
						if (!e) return false;
						var el = e.target || e.srcElement || e || false;
						while (el && el !== p) {
							el = el.parentNode || false;
						}
						return (el !== false);
					}

					/**
					 * extend obj function
					 */
					function extend(a, b) {
						for (var key in b) {
							if (b.hasOwnProperty(key)) {
								a[key] = b[key];
							}
						}
						return a;
					}

					/**
					 * SelectFx function
					 */
					function SelectFx(el, options) {
						this.el = el;
						this.options = extend({}, this.options);
						extend(this.options, options);
						this._init();
					}

					/**
					 * SelectFx options
					 */
					SelectFx.prototype.options = {
						// if true all the links will open in a new tab.
						// if we want to be redirected when we click an option, we need to define a data-link attr on the option of the native select element
						newTab: true,
						// when opening the select element, the default placeholder (if any) is shown
						stickyPlaceholder: true,
						// callback when changing the value
						onChange: function (val) { return false; }
					};

					/**
					 * init function
					 * initialize and cache some vars
					 */
					SelectFx.prototype._init = function () {
						// check if we are using a placeholder for the native select box
						// we assume the placeholder is disabled and selected by default
						var selectedOpt = this.el.querySelector('option[selected]');
						this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;

						// get selected option (either the first option with attr selected or just the first option)
						this.selectedOpt = selectedOpt || this.el.querySelector('option');

						// create structure
						this._createSelectEl();

						// all options
						this.selOpts = [].slice.call(this.selEl.querySelectorAll('li[data-option]'));

						// total options
						this.selOptsCount = this.selOpts.length;

						// current index
						this.current = this.selOpts.indexOf(this.selEl.querySelector('li.cs-selected')) || -1;

						// placeholder elem
						this.selPlaceholder = this.selEl.querySelector('span.cs-placeholder');

						// init events
						this._initEvents();
					};

					/**
					 * creates the structure for the select element
					 */
					SelectFx.prototype._createSelectEl = function () {
						var self = this, options = '', createOptionHTML = function (el) {
							var optclass = '', classes = '', link = '';

							if (el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder) {
								classes += 'cs-selected ';
								this.foundSelected = true;
							}
							// extra classes
							if (el.getAttribute('data-class')) {
								classes += el.getAttribute('data-class');
							}
							// link options
							if (el.getAttribute('data-link')) {
								link = 'data-link=' + el.getAttribute('data-link');
							}

							if (classes !== '') {
								optclass = 'class="' + classes + '" ';
							}

							return '<li ' + optclass + link + ' data-option data-value="' + el.value + '"><span>' + el.textContent + '</span></li>';
						};

						[].slice.call(this.el.children).forEach(function (el) {
							if (el.disabled) { return; }

							var tag = el.tagName.toLowerCase();

							if (tag === 'option') {
								options += createOptionHTML(el);
							}
							else if (tag === 'optgroup') {
								options += '<li class="cs-optgroup"><span>' + el.label + '</span><ul>';
								[].slice.call(el.children).forEach(function (opt) {
									options += createOptionHTML(opt);
								});
								options += '</ul></li>';
							}
						});

						var opts_el = '<div class="cs-options"><ul>' + options + '</ul></div>';
						this.selEl = document.createElement('div');
						this.selEl.className = this.el.className;
						this.selEl.tabIndex = this.el.tabIndex;
						this.selEl.innerHTML = '<span class="cs-placeholder">' + this.selectedOpt.textContent + '</span>' + opts_el;
						this.el.parentNode.appendChild(this.selEl);
						this.selEl.appendChild(this.el);
					};

					/**
					 * initialize the events
					 */
					SelectFx.prototype._initEvents = function () {
						var self = this;

						// open/close select
						this.selPlaceholder.addEventListener('click', function () {
							self._toggleSelect();
						});

						// clicking the options
						this.selOpts.forEach(function (opt, idx) {
							opt.addEventListener('click', function () {
								self.current = idx;
								self._changeOption();
								// close select elem
								self._toggleSelect();
							});
						});

						// close the select element if the target it´s not the select element or one of its descendants..
						document.addEventListener('click', function (ev) {
							var target = ev.target;
							if (self._isOpen() && target !== self.selEl && !hasParent(target, self.selEl)) {
								self._toggleSelect();
							}
						});

						// keyboard navigation events
						this.selEl.addEventListener('keydown', function (ev) {
							var keyCode = ev.keyCode || ev.which;

							switch (keyCode) {
								// up key
								case 38:
									ev.preventDefault();
									self._navigateOpts('prev');
									break;
								// down key
								case 40:
									ev.preventDefault();
									self._navigateOpts('next');
									break;
								// space key
								case 32:
									ev.preventDefault();
									if (self._isOpen() && typeof self.preSelCurrent !== 'undefined' && self.preSelCurrent !== -1) {
										self._changeOption();
									}
									self._toggleSelect();
									break;
								// enter key
								case 13:
									ev.preventDefault();
									if (self._isOpen() && typeof self.preSelCurrent !== 'undefined' && self.preSelCurrent !== -1) {
										self._changeOption();
										self._toggleSelect();
									}
									break;
								// esc key
								case 27:
									ev.preventDefault();
									if (self._isOpen()) {
										self._toggleSelect();
									}
									break;
							}
						});
					};

					/**
					 * navigate with up/dpwn keys
					 */
					SelectFx.prototype._navigateOpts = function (dir) {
						if (!this._isOpen()) {
							this._toggleSelect();
						}

						var tmpcurrent = typeof this.preSelCurrent !== 'undefined' && this.preSelCurrent !== -1 ? this.preSelCurrent : this.current;

						if (dir === 'prev' && tmpcurrent > 0 || dir === 'next' && tmpcurrent < this.selOptsCount - 1) {
							// save pre selected current - if we click on option, or press enter, or press space this is going to be the index of the current option
							this.preSelCurrent = dir === 'next' ? tmpcurrent + 1 : tmpcurrent - 1;
							// remove focus class if any..
							this._removeFocus();
							// add class focus - track which option we are navigating
							classie.add(this.selOpts[this.preSelCurrent], 'cs-focus');
						}
					};

					/**
					 * open/close select
					 * when opened show the default placeholder if any
					 */
					SelectFx.prototype._toggleSelect = function () {
						// remove focus class if any..
						this._removeFocus();

						if (this._isOpen()) {
							if (this.current !== -1) {
								// update placeholder text
								this.selPlaceholder.textContent = this.selOpts[this.current].textContent;
							}
							classie.remove(this.selEl, 'cs-active');
						}
						else {
							if (this.hasDefaultPlaceholder && this.options.stickyPlaceholder) {
								// everytime we open we wanna see the default placeholder text
								this.selPlaceholder.textContent = this.selectedOpt.textContent;
							}
							classie.add(this.selEl, 'cs-active');
						}
					};

					/**
					 * change option - the new value is set
					 */
					SelectFx.prototype._changeOption = function () {
						// if pre selected current (if we navigate with the keyboard)...
						if (typeof this.preSelCurrent !== 'undefined' && this.preSelCurrent !== -1) {
							this.current = this.preSelCurrent;
							this.preSelCurrent = -1;
						}

						// current option
						var opt = this.selOpts[this.current];

						// update current selected value
						this.selPlaceholder.textContent = opt.textContent;

						// change native select element´s value
						this.el.value = opt.getAttribute('data-value');

						// remove class cs-selected from old selected option and add it to current selected option
						var oldOpt = this.selEl.querySelector('li.cs-selected');
						if (oldOpt) {
							classie.remove(oldOpt, 'cs-selected');
						}
						classie.add(opt, 'cs-selected');

						// if there´s a link defined
						if (opt.getAttribute('data-link')) {
							// open in new tab?
							if (this.options.newTab) {
								window.open(opt.getAttribute('data-link'), '_blank');
							}
							else {
								window.location = opt.getAttribute('data-link');
							}
						}

						// callback
						this.options.onChange(this.el.value);
					};

					/**
					 * returns true if select element is opened
					 */
					SelectFx.prototype._isOpen = function (opt) {
						return classie.has(this.selEl, 'cs-active');
					};

					/**
					 * removes the focus class from the option
					 */
					SelectFx.prototype._removeFocus = function (opt) {
						var focusEl = this.selEl.querySelector('li.cs-focus');
						if (focusEl) {
							classie.remove(focusEl, 'cs-focus');
						}
					};

					/**
					 * add to global namespace
					 */
					window.SelectFx = SelectFx;

				})(window);

				(function () {
					[].slice.call(document.querySelectorAll('select.cs-select')).forEach(function (el) {
						new SelectFx(el);
					});
				})();

				// Slider Projects
				$("#projects").lightSlider({
					item: 1,
					autoWidth: false,
					slideMove: 1, // slidemove will be 1 if loop is true
					slideMargin: 0,

					addClass: '',
					mode: "slide",
					useCSS: true,
					cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
					easing: 'linear', //'for jquery animation',////

					speed: 1000, //ms'
					auto: true,
					pauseOnHover: true,
					loop: true,
					slideEndAnimation: true,
					pause: 5000,

					keyPress: false,
					controls: false,
					prevHtml: '',
					nextHtml: '',

					rtl: false,
					adaptiveHeight: false,

					vertical: false,
					verticalHeight: 500,
					vThumbWidth: 100,

					thumbItem: 10,
					pager: true,
					gallery: false,
					galleryMargin: 5,
					thumbMargin: 5,
					currentPagerPosition: 'middle',

					enableTouch: true,
					enableDrag: true,
					freeMove: true,
					swipeThreshold: 40,

					responsive: [],

					onBeforeStart: function (el) { },
					onSliderLoad: function (el) {
						// if($(window).width() > 960) {
						// 	resizeDiv();
						// }
					},
					onBeforeSlide: function (el) { },
					onAfterSlide: function (el) { },
					onBeforeNextSlide: function (el) { },
					onBeforePrevSlide: function (el) { }
				});

				var planSlider = $("#plans").lightSlider({
					item: 1,
					autoWidth: false,
					slideMove: 1, // slidemove will be 1 if loop is true
					slideMargin: 0,

					addClass: '',
					mode: "slide",
					useCSS: true,
					cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
					easing: 'linear', //'for jquery animation',////

					speed: 1000, //ms'
					auto: false,
					pauseOnHover: true,
					loop: true,
					slideEndAnimation: true,
					pause: 5000,

					keyPress: false,
					controls: true,
					prevHtml: '',
					nextHtml: '',

					rtl: false,
					adaptiveHeight: false,

					vertical: false,
					verticalHeight: 500,
					vThumbWidth: 100,

					thumbItem: 10,
					pager: false,
					gallery: false,
					galleryMargin: 5,
					thumbMargin: 5,
					currentPagerPosition: 'middle',

					enableTouch: true,
					enableDrag: true,
					freeMove: true,
					swipeThreshold: 40,

					responsive: [],

					onBeforeStart: function (el) { },
					onSliderLoad: function (el) {
						// if($(window).width() > 960) {
						// 	resizeDiv();
						// }
						$el = el.find('li.active');
						$data = $el.data('active');

						$('.facts table .table__row').each(function () {
							$tableData = $(this).data('active');
							console.log('selected:' + $data);
							console.log('highlighted:' + $tableData);

							if ($data === $tableData) {
								$(this).addClass('highlight');
							} else {
								$(this).removeClass('highlight');
							}
						});
					},
					onBeforeSlide: function (el) { },
					onAfterSlide: function (el) {
						$el = el.find('li.active');
						$data = $el.data('active');

						$('.facts table .table__row').each(function () {
							$tableData = $(this).data('active');

							if ($data === $tableData) {
								$(this).addClass('highlight');
							} else {
								$(this).removeClass('highlight');
							}
						});
					},
					onBeforeNextSlide: function (el) { },
					onBeforePrevSlide: function (el) { }
				});

				$(".facts table .table__row").each(function (index) {
					$(this).on("click", function () {
						console.log(index + ": " + $(this).text());
						planSlider.goToSlide(index + 1);
					});
				});

				// $('#plans li').each(function() {
				// 	if($(this).hasClass('active')) {
				// 		$data = $(this).data('active');
				// 		console.log($data);
				// 	}
				// });

				$('.facts table').find('tr').each(function () {
					$(this).find('th').eq(0).before('<th class="eye"></th>');
					$(this).find('td').eq(0).before('<td class="eye"><svg class="icon icon--eye"><use xlink:href="#eye"/></svg></td>');
				});

				// Slider Projects
				$("#project").lightSlider({
					item: 1,
					autoWidth: false,
					slideMove: 1, // slidemove will be 1 if loop is true
					slideMargin: 0,

					addClass: '',
					mode: "slide",
					useCSS: true,
					cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
					easing: 'linear', //'for jquery animation',////

					speed: 1000, //ms'
					auto: true,
					pauseOnHover: true,
					loop: true,
					slideEndAnimation: true,
					pause: 5000,

					keyPress: false,
					controls: false,
					prevHtml: '',
					nextHtml: '',

					rtl: false,
					adaptiveHeight: false,

					vertical: false,
					verticalHeight: 500,
					vThumbWidth: 100,

					thumbItem: 10,
					pager: true,
					gallery: false,
					galleryMargin: 5,
					thumbMargin: 5,
					currentPagerPosition: 'middle',

					enableTouch: true,
					enableDrag: true,
					freeMove: true,
					swipeThreshold: 40,

					responsive: [],

					onBeforeStart: function (el) { },
					onSliderLoad: function (el) {
						// if($(window).width() > 960) {
						// 	resizeDiv();
						// }
					},
					onBeforeSlide: function (el) { },
					onAfterSlide: function (el) { },
					onBeforeNextSlide: function (el) { },
					onBeforePrevSlide: function (el) { }
				});

				// Slider Projects
				$("#properties").lightSlider({
					item: 1,
					autoWidth: false,
					slideMove: 1, // slidemove will be 1 if loop is true
					slideMargin: 0,

					addClass: '',
					mode: "slide",
					useCSS: true,
					cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
					easing: 'linear', //'for jquery animation',////

					speed: 1000, //ms'
					auto: true,
					pauseOnHover: true,
					loop: true,
					slideEndAnimation: true,
					pause: 5000,

					keyPress: false,
					controls: false,
					prevHtml: '',
					nextHtml: '',

					rtl: false,
					adaptiveHeight: false,

					vertical: false,
					verticalHeight: 500,
					vThumbWidth: 100,

					thumbItem: 10,
					pager: true,
					gallery: false,
					galleryMargin: 5,
					thumbMargin: 5,
					currentPagerPosition: 'middle',

					enableTouch: true,
					enableDrag: true,
					freeMove: true,
					swipeThreshold: 40,

					responsive: [],

					onBeforeStart: function (el) { },
					onSliderLoad: function (el) {
						// if($(window).width() > 960) {
						// 	resizeDiv();
						// }
					},
					onBeforeSlide: function (el) { },
					onAfterSlide: function (el) { },
					onBeforeNextSlide: function (el) { },
					onBeforePrevSlide: function (el) { }
				});
			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function () {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// Google Maps API w ACF and async
// renderMap
function initialize() {
	function renderMap($el) {
		// var
		var $markers = $el.find('.map__marker');

		var styles = [{ "featureType": "landscape", "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }] }, { "featureType": "poi", "stylers": [{ "saturation": -100 }, { "lightness": 51 }, { "visibility": "simplified" }] }, { "featureType": "road.highway", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] }, { "featureType": "road.arterial", "stylers": [{ "saturation": -100 }, { "lightness": 30 }, { "visibility": "on" }] }, { "featureType": "road.local", "stylers": [{ "saturation": -100 }, { "lightness": 40 }, { "visibility": "on" }] }, { "featureType": "transit", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] }, { "featureType": "administrative.province", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "labels", "stylers": [{ "visibility": "on" }, { "lightness": -25 }, { "saturation": -100 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }] }];

		// vars
		var args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			scrollwheel: false,
			mapTypeControlOptions: {
				mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'taxiMap']
			}
		};

		// create map
		var map = new google.maps.Map($el[0], args);

		// styling
		var styledMapOptions = {
			name: 'Greyscale'
		};

		var taxiMapType = new google.maps.StyledMapType(styles, styledMapOptions);

		map.mapTypes.set('taxiMap', taxiMapType);
		map.setMapTypeId('taxiMap');

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			addMarker(jQuery(this), map);
		});

		// center map
		centerMap(map);
	}

	// addMarker
	function addMarker($marker, map) {
		// var
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		var marker = new google.maps.Marker({
			position: latlng,
			map: map
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function () {
				infowindow.open(map, marker);
			});
		}

	}

	// centerMap
	function centerMap(map) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		jQuery.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length === 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(15);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	jQuery('.map__container').each(function () {
		renderMap(jQuery(this));
	});
}

function loadScript() {
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp' +
		'&callback=initialize&key=AIzaSyBfK9LhfgRMxRBcEb6swj4g6mFM9mdfCJE';
	document.body.appendChild(script);
}

window.onload = loadScript;
